import { map } from 'lodash';
import React, { useCallback, useContext, useMemo } from 'react';
import Dropdown from '../../../../controls/Dropdown';
import TreeContext from '../../TreeContext';
import styles from './ActionsAddon.scss';
export const Separator = Symbol('separator');
const ActionsAddon = ({ title, actions, node = null, selectOnAction = false, dataCy = 'tree-node-actions', }) => {
    const treeContext = useContext(TreeContext);
    const handleClick = useCallback(action => () => {
        const { adapter, plugins, treeState } = treeContext;
        const { selection: selectionPlugin } = plugins;
        if (selectOnAction && selectionPlugin) {
            selectionPlugin.setSelection(treeState, node, { adapter });
        }
        action(node, treeContext);
    }, [treeContext, node, selectOnAction]);
    const dropdownActions = useMemo(() => map(actions, item => {
        if (item === Separator) {
            return {
                label: 'separator',
                disabled: true,
                hasStrike: true,
            };
        }
        const { title, action, className, hasStrike, disabled, icon } = item;
        return {
            label: title,
            linkClassName: className,
            onClick: handleClick(action),
            hasStrike,
            disabled,
            icon: icon === null || icon === void 0 ? void 0 : icon.name,
            iconType: icon === null || icon === void 0 ? void 0 : icon.type,
            dataCy: (item === null || item === void 0 ? void 0 : item.dataCy) || String(item.id),
        };
    }), [actions, handleClick]);
    if (!actions.length) {
        return null;
    }
    return (<span className={styles.containerClassName}>
      <Dropdown actions={dropdownActions} dataCy={dataCy} icon={[
        {
            className: 'display-inline-block no-margin caret',
            name: 'caret',
        },
    ]} position="right" title={title}/>
    </span>);
};
export default ActionsAddon;
